import HttpClientToken from '../../services/HttpClientToken';

import { AutoridadExhortoRecibidoProps, defaultAutoridadExhortoRecibido } from '../../interfaces/catalogos/AutoridadExhortoRecibidoInterface';

export const AutoridadExhortoRecibido = () => {

    return new Promise<AutoridadExhortoRecibidoProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/AutoridadExhortoRecibido/', token)
            .then( ({ data } : { data : AutoridadExhortoRecibidoProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ObtenerAutoridadExhortoRecibido = () => {

    return new Promise<AutoridadExhortoRecibidoProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/AutoridadExhortoRecibido/ObtenerAutoridadExhortoRecibido', token)
            .then( ({ data } : { data : AutoridadExhortoRecibidoProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ActualizarAutoridadExhortoRecibido = ( params: AutoridadExhortoRecibidoProps ) => {

    return new Promise<AutoridadExhortoRecibidoProps>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/AutoridadExhortoRecibido/Actualizar', params, token)
            .then( ({ data } : { data : AutoridadExhortoRecibidoProps} ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultAutoridadExhortoRecibido } );
            });

        }

    });

}

export const AgregarAutoridadExhorto = ( params: AutoridadExhortoRecibidoProps ) => {

    return new Promise<AutoridadExhortoRecibidoProps>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/AutoridadExhorto/Agregar', params, token)
            .then( ({ data } : { data : AutoridadExhortoRecibidoProps} ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultAutoridadExhortoRecibido } );
            });

        }

    });

}
